import { bindMethod } from 'helpers/bind';
import Component from 'navigation/component/Component';
export default class Pagination extends Component {
    previous = null;
    _current;
    nextPageFrom = null;
    pages;
    items = 0;
    _seen = 0;
    get current() {
        return this._current;
    }
    set current(value) {
        this.previous = this._current;
        this._current = value;
    }
    get seen() {
        return this._seen;
    }
    set seen(value) {
        this._seen = value;
        if (this.refs.seenCount)
            this.refs.seenCount.innerHTML = value.toString();
        if (this.refs.trackBar)
            this.refs.trackBar.style.setProperty('--track-width', `${(value / this.items) * 100}%`);
        if (value === this.items)
            // in case we navigate forward to a first page BUT we have stored all the items
            this.refs.loadMore?.remove();
    }
    constructor(el, options) {
        super(el, options);
        this.pages = parseInt(options.pages);
        this.current = parseInt(options.current);
        this.nextPageFrom = this.current;
        this.items = parseInt(this.el.dataset.total);
        this.seen = options.seen;
    }
    initialized() {
        super.initialized();
    }
    setSeen(value) {
        this.seen = value;
    }
    bindEvents(add = true) {
        const method = bindMethod(add);
        if (this.refs.loadMore)
            this.refs.loadMore[method]('click', (e) => this.load(e));
        if (this.refs.loadLess)
            this.refs.loadLess[method]('click', (e) => this.load(e));
    }
    load(event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        const direction = parseInt(event.currentTarget.dataset.delta);
        let from = 0;
        if (direction < 0)
            from = this.current;
        else
            from = this.nextPageFrom;
        if (from + direction > 0 && from + direction <= this.pages) {
            this.emit('load', from + direction, direction);
            this.refs[direction === 1 ? 'loadMore' : 'loadLess'].classList.add('loading');
        }
    }
    onPageLoaded(page, items, direction) {
        if (page > this.nextPageFrom)
            this.nextPageFrom = page;
        this.current = page;
        this.bindRefs();
        this.seen += items;
        if (page === 1)
            if (this.refs.loadLess)
                this.refs.loadLess.remove();
        if (page === this.pages)
            if (this.refs.loadMore)
                this.refs.loadMore.remove();
        if (this.refs.loadLess)
            this.refs.loadLess.classList.remove('loading');
        if (this.refs.loadMore)
            this.refs.loadMore.classList.remove('loading');
    }
}
